import Loading from "../../../../Loading/Loading"
import CardMessage from "./CardMessage"

export default function MessageBox({ list, progressElem, showProgress, progressInner, showLoadingMessages }) {

    return (
        <div className="message_box">

            {showLoadingMessages ?
                <div className="loading_chat">
                    <div className="main_loader_chat">
                        <div className="loader loader_chat"></div>
                    </div>
                </div>
                : null}

            {list.map((elem, index) => {

                return (
                    <CardMessage
                        progressFile={(list.length == index + 1 ? 'progress' : '')}
                        progressInner={progressInner}
                        key={elem.id}
                        message={elem}
                        progressElem={progressElem}
                        showProgress={showProgress}
                    />
                )

            })}

        </div>
    )

}